import { useEffect } from 'react'

import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import {
  InvitationStatus,
  useInvitationLinkQuery,
} from 'generated/generated-graphql'
import { useErrorToast } from 'utils/toast'

export const useInvitationLink = () => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const toast = useErrorToast()

  const { invitation } = router.query
  const { data, loading } = useInvitationLinkQuery({
    variables: {
      where: {
        id: {
          eq: invitation as string,
        },
      },
    },
    skip: !invitation,
  })

  useEffect(() => {
    if (!invitation) {
      return
    }

    // No Invitation Link
    if (!data?.invitationLink && !loading) {
      toast({
        title: t('InvitationLinkToast.invalidLink'),
        description: '',
      })
      // Remove query param
      router.replace(router.pathname, undefined, { shallow: true })
      return
    }

    if (data?.invitationLink?.status === InvitationStatus.Expired) {
      toast({
        title: t('InvitationLinkToast.expiredLink'),
        description: '',
      })
      // Remove query param
      router.replace(router.pathname, undefined, { shallow: true })
      return
    }

    if (data?.invitationLink?.status === InvitationStatus.Accepted) {
      toast({
        title: t('InvitationLinkToast.acceptedLink'),
        description: '',
      })
      // Remove query param
      router.replace(router.pathname, undefined, { shallow: true })
      return
    }
  }, [data?.invitationLink, invitation, loading, router, t, toast])

  return {
    data,
    loading,
    invitationId: invitation,
  }
}
